import { fork } from 'redux-saga/effects';

import { userSagas } from './domain/user/forces/sagas';

export default function* rootSaga() {
  yield fork(userSagas);
}
